import { FC } from 'react';
import { defaultIconProps, IconProps } from './IconProps';

export const IconArrowDownLeft: FC<IconProps> = ({ size, color, strokeWidth, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M16.6663 3.33337V4.50004C16.6663 7.3003 16.6663 8.70043 16.1214 9.76999C15.642 10.7108 14.8771 11.4757 13.9363 11.9551C12.8667 12.5 11.4666 12.5 8.66634 12.5H3.33301M3.33301 12.5L7.49967 8.33337M3.33301 12.5L7.49967 16.6667"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

IconArrowDownLeft.defaultProps = defaultIconProps;
